"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.round = void 0;
var round_to_int_1 = require("../round-to-int");
var round = function (digit) {
    var powAmount = Math.pow(10, digit);
    return function (target) { return (0, round_to_int_1.roundToInt)(powAmount * target) / powAmount; };
};
exports.round = round;
